<template>
    <div>
        <modal-user :user="userComputed" v-if="status" />
        <modal-contact :user="userComputed" v-if="status" />
        <modal-contact-email :user="userComputed" v-if="status" />
        <modal-contact-phone :user="userComputed" v-if="status" />
        <modal-contact-whatsapp :user="userComputed" v-if="status" />
        <modal-contact-notification :user="userComputed" v-if="status" />

        <mobile-menu :user="userComputed" />
    </div>
</template>

<script>
    import ModalUser from '@/Components/BaseModal/ModalUser'
    import ModalContact from '@/Components/BaseModal/ModalContact'
    import ModalContactEmail from '@/Components/BaseModal/ModalContactEmail'
    import ModalContactPhone from '@/Components/BaseModal/ModalContactPhone'
    import ModalContactWhatsapp from '@/Components/BaseModal/ModalContactWhatsapp'
    import ModalContactNotification from '@/Components/BaseModal/ModalContactNotification'

    import MobileMenu from '@/Components/MobileMenu'

    import { mapGetters, mapActions } from 'vuex'

    export default {
        components: {
            ModalUser,
            ModalContact,
            ModalContactEmail,
            ModalContactPhone,
            ModalContactWhatsapp,
            ModalContactNotification,
            MobileMenu,
        },

        data() {
            return {}
        },

        computed: {
            ...mapGetters('User', ['user']),
            userComputed() {
                let user = {
                    name: this.userNameComputed,
                    email: this.userEmailComputed,
                    image: 'https://cdn.appfacilita.com/' + this.userPhotoComputed,
                    phone: this.userPhoneComputed,
                    creci: this.userCRECIComputed,
                }
                return user
            },

            userNameComputed() {
                let fullName = ''
                let name = this.user.first_name ? this.user.first_name : ''

                fullName = String(name).split(' ')

                if (fullName.length < 2) {
                    fullName = fullName.shift()
                } else {
                    fullName = fullName.shift() + ' ' + fullName.pop()
                }

                return this.user ? fullName : ''
            },

            userEmailComputed() {
                return this.user && this.user.email ? this.user.email : ''
            },

            userPhotoComputed() {
                if (this.user.photo || this.user.cover)
                    return this.user.photo ? this.user.photo : this.user.cover
                else return null
            },

            userPhoneComputed() {
                if (this.user.phone || this.user.mobile)
                    return this.user.phone ? this.maskPhone(this.user.phone) : this.maskPhone(this.user.mobile)
                else return null
            },

            userCRECIComputed() {
                return this.user && this.user.creci ? this.user.creci : ''
            },

            status() {
                return this.user ? true : false
            },
        },

        created() {
            this.$nextTick(() => {
                /**
                 * Faz a requisição do User
                 */
                this.setUser()
            })
        },

        methods: {
            ...mapActions('User', ['setUser']),

            maskPhone(value) {
                let str = value.replace(/\D/g, '').replace(/^0/, '')

                if (str.length > 10) return str.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3')
                else if (str.length > 5) return str.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3')
                else if (str.length > 2) return str.replace(/^(\d\d)(\d{0,5})/, '$1-$2')
                else return str.replace(/^(\d*)/, '($1')
            },
        },
    }
</script>
